import api from "./index";

// Contact CRUD Operations
export const getContacts = (params = {}) =>
  api.get("lead-management/contacts/", { params });

export const getContact = (id) =>
  api.get(`lead-management/contacts/${id}/`);

export const createContact = (data) =>
  api.post("lead-management/contacts/", data);

export const updateContact = (id, data) =>
  api.put(`lead-management/contacts/${id}/`, data);

export const deleteContact = (id) =>
  api.delete(`lead-management/contacts/${id}/`);

// Contact Conversion
export const convertContactToLead = (contactId, data = {}) =>
  api.post(`lead-management/contacts/${contactId}/convert-to-lead/`, data);

export const checkDuplicateContact = (email, phone = null) =>
  api.post("lead-management/contacts/check-duplicate/", { email, phone });

// Buyer Requirements
export const getBuyerRequirements = (contactId) =>
  api.get(`lead-management/contacts/${contactId}/buyer-requirements/`);

export const createOrUpdateBuyerRequirements = (contactId, data) =>
  api.post(`lead-management/contacts/${contactId}/buyer-requirements/`, data);

export const updateBuyerRequirements = (contactId, data) =>
  api.put(`lead-management/contacts/${contactId}/buyer-requirements/update/`, data);

export const deleteBuyerRequirements = (contactId) =>
  api.delete(`lead-management/contacts/${contactId}/buyer-requirements/update/`);

export const matchPropertiesForBuyer = (contactId, params = {}) =>
  api.get(`lead-management/contacts/${contactId}/match-properties/`, { params });

// Import Contacts CSV
export const importContactsCsv = (formData) =>
  api.post(`lead-management/contacts/import/csv/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000, // 30s — bulk import should finish in well under this
  });

// Export Contacts CSV (Vault-friendly)
// Accepts the same filter params as the contact list (contact_type, source,
// is_lead, is_buyer_advocate, search) so the user can export a filtered slice.
export const exportContactsVaultCsv = (params = {}) =>
  api.get(`lead-management/contacts/export/vault-csv/`, { params, responseType: 'blob' });

// Recent Contacts imports, with the file and an undo.
export const getContactImportJobs = () =>
  api.get(`lead-management/contacts/import-jobs/`);

export const undoContactImport = (jobId) =>
  api.post(`lead-management/contacts/import-jobs/${jobId}/undo/`);

export const downloadContactImportFile = (jobId) =>
  api.get(`lead-management/contacts/import-jobs/${jobId}/file/`, { responseType: 'blob' });
